// extracted by mini-css-extract-plugin
export default {"under_images":"ImagesUnderContent_under_images__dniyF"};